var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner_app"},[_c('div',{ref:"wrapLemontree",class:[
      'wrap_lemontree',
      { 'active_snb' : _vm.getIsActiveGnb && _vm.isRequiresAuth },
      { 'wrap_full' : _vm.isBodyFull },
      { 'wrap_middle' : _vm.isBodyMiddle },
    ],attrs:{"id":"lemontreeWrap"}},[(_vm.isRequiresAuth)?_c('Header',{on:{"onClickSnb":function($event){return _vm.onClickSnb()}}}):_vm._e(),(_vm.isRequiresAuth)?_c('Snb'):_vm._e(),_c('Content',{attrs:{"isBodyBg":_vm.isBodyBg,"isBodyMiddle":_vm.isBodyMiddle}},[_vm._t("default")],2),(_vm.isRequiresAuth)?_c('Footer'):_vm._e()],1),_vm._t("popup")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }